import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "img-area" }
const _hoisted_2 = ["src"]

import { ref } from 'vue';

interface Props {
  exatoms: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AtomImage',
  props: {
    exatoms: {}
  },
  setup(__props: any) {

const props = __props;

const imgDialogFlg = ref(false);
const imgTileHover = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: "img-wrapper",
    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (imgTileHover.value = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (imgTileHover.value = false))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["blk-curtain", { show: imgTileHover.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (imgDialogFlg.value = true))
    }, [
      _createVNode(_component_q_icon, {
        color: "white",
        name: "mdi-magnify-plus"
      })
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: 'data:image/svg+xml;base64,' + props.exatoms,
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: imgDialogFlg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((imgDialogFlg).value = $event)),
      class: "formula-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close"
            }, null, 512), [
              [_directive_close_popup]
            ]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, {
                  src: 'data:image/svg+xml;base64,' + props.exatoms
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 32))
}
}

})